module.exports = __webpack_public_path__ + "img/coleslaw_roedkaal.3671aec3.jpg";